import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface VirtualCardCapTooltipProps {
  openLeft: boolean
}

const VirtualCardCapTooltip: React.FC<VirtualCardCapTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const appName = useSelector(selectAppName)
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        {translate(
          '${virtualCardCap} is the max number of virtual cards cards this user can create per registered credit card ("Account"). This cap is controlled by ${appName}, and can be manually updated by ${appName} upon request (on a case-by-case basis).',
          {
            virtualCardCap: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Virtual card cap')}
              </span>
            ),
            appName: appName,
          },
        )}
      </p>
    </Tooltip>
  )
}

export default VirtualCardCapTooltip
